import React from 'react';
import EnhancedTable, {
  EnhancedTableHeader,
  EnhancedTableHeaderCell,
  EnhancedTableBody,
  EnhancedTableRow,
  EnhancedTableCell,
  TableLoading,
  TableEmpty,
  ActionButton,
  TableSummaryRow,
  StatusBadge,
} from '../common/EnhancedTable';

const AdsTable = ({ className = '', tableClassName = '', containerClassName = '', children, ...props }) => (
  <div className={`ads-table ${className}`.trim()}>
    <EnhancedTable
      tableClassName={tableClassName}
      containerClassName={containerClassName}
      {...props}
    >
      {children}
    </EnhancedTable>
  </div>
);

export {
  AdsTable,
  EnhancedTableHeader as AdsTableHeader,
  EnhancedTableHeaderCell as AdsTableHeaderCell,
  EnhancedTableBody as AdsTableBody,
  EnhancedTableRow as AdsTableRow,
  EnhancedTableCell as AdsTableCell,
  TableLoading as AdsTableLoading,
  TableEmpty as AdsTableEmpty,
  ActionButton as AdsTableActionButton,
  TableSummaryRow as AdsTableSummaryRow,
  StatusBadge as AdsTableStatusBadge,
};

export default AdsTable;
